import { AdditionalAssetsStoreType } from "store/type";

export const initGlobalState: any = {
  kycReminderLoading: null,
};
